<div class="chain-input" [formGroup]="$any(formArray)" appChainFocus *ngIf="formArray.length !== 0">
  <div class="chain-input__item" *ngFor="let control of formArray.controls; let i = index">
    <mat-form-field appearance="outline">
      <input
        matInput
        [maxLength]="1"
        [inputLength]="1"
        [formControlName]="i"
        appChainFocusItem
        [clearForm]="clearForm"
        autocomplete="off"
        type="tel"
        [readonly]="isDisabled"
      >
    </mat-form-field>
  </div>
</div>
